export default __webpack_public_path__ + "static/media/Bank Islamic Cheque.ec3302c4.png";